import React from "react";
import styles from "../styles.module.scss";

const Arrows = ({ order, isSet }) => {
    const selectedUp = isSet && !order ? styles.selected_arrow : null;
    const selectedDown = isSet && order ? styles.selected_arrow : null;
    return (
      <div className={styles.arrows_container}>
        <i className={`ico ico-chevron ${styles.arrow} ${styles.up} ${selectedUp}`} />
        <i className={`ico ico-chevron ${styles.arrow} ${styles.down} ${selectedDown}`} />
      </div>
    );
};
export default Arrows;
